import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper/modules";

const automationCases = [
  {
    title: "숏폼, 카드뉴스",
    image: "/assets/images/swipe01.png",
    gradient: "from-purple-800 to-fuchsia-800",
    tags: [
      "SNS 콘텐츠",
      "릴스/쇼츠",
      "템플릿 지원",
      "영상 자동화",
      "인스타그램",
      "유튜브",
      "틱톡",
    ],
    hashtags: [
      "shorts",
      "reels",
      "틱톡",
      "콘텐츠자동화",
      "숏폼제작",
      "브랜드마케팅",
      "트렌드콘텐츠",
      "애니메이션영상",
      "카드뉴스제작",
      "AI영상",
    ],
  },
  {
    title: "블로그 콘텐츠",
    image: "/assets/images/swipe02.png",
    gradient: "from-blue-800 to-indigo-800",
    tags: [
      "SEO 최적화",
      "자동 발행",
      "마케팅",
      "네이버 블로그",
      "티스토리",
      "워드프레스",
      "블로그",
    ],
    hashtags: ["블로그운영", "SEO", "콘텐츠마케팅", "자동화", "키워드분석"],
  },
];

export default function AutomationBanner() {
  return (
    <section className="relative bg-black text-white px-6 md:px-12 overflow-hidden">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Pagination, Autoplay]}
      >
        {automationCases.map((item, idx) => (
          <SwiperSlide key={idx}>
            <section className="relative text-white px-6 md:px-12 overflow-hidden">
              {/* 상단 텍스트 */}
              <div className="mx-auto py-24 grid grid-cols-1 md:grid-cols-2 justify-between relative z-10">
                <div>
                  <h1 className="text-4xl md:text-5xl font-bold leading-tight">
                    {item.title}
                  </h1>
                  <h2 className="text-xl mt-4 leading-tight">
                    {item.description}
                  </h2>
                </div>
              </div>
              <div className="relative w-full">
                <img src={item.image} alt={item.title} className="w-full" />
              </div>
            </section>
          </SwiperSlide>
        ))}
      </Swiper>
      <style>
        {`
          .swiper-pagination-bullet {
            background: rgba(255, 255, 255, 0.4);
            opacity: 1;
          }
          .swiper-pagination-bullet-active {
            background: #ffffff;
          }
        `}
      </style>
    </section>
  );
}
